import { SavedSearch } from "src/types/neighborhoodSearch";
import { isAddressSavedSearch } from "./isAddressSavedSearch";
import { isCombinedSavedSearch } from "./isCombinedSavedSearch";

/**
 * Determines if a saved search is a region-based search (not an address search or combined search)
 * Region searches are the ones that can be re-run with new parameters
 */
export const isRegionSearch = (search: SavedSearch): boolean => {
  return !isAddressSavedSearch(search) && !isCombinedSavedSearch(search);
};